(function () {
    'use strict';

    var module = angular.module('uwAgenda.email');
    module.controller('DetailEmailController', ['$scope', 'AppConfig', 'Alert', 'EmailService', 'SharedAgendaService', '$uibModalInstance', 'MultipleFileUploadBroadcast', 'HelperService', 'email', 'signature', DetailEmailControllerFn]);

    /* controlle for email modal */
    function DetailEmailControllerFn($scope, AppConfig, Alert, EmailService, SharedAgendaService, $uibModalInstance, MultipleFileUploadBroadcast, HelperService, email, signature) {
        var vm = this;

        vm.uploadUrl = "";
        vm.clearAll = false;
        vm.attachments = [];
        vm.copyToMe = false;

        activate();

        function listen() {
            // listen on changed client
            var listener = $scope.$on(MultipleFileUploadBroadcast.UpdateFileList, function (event, attachments) {
                vm.attachments = attachments;
            });

            // on destroy
            $scope.$on("$destroy", function () {
                listener();
                listener = null;
            });
        }

        /* send current item */
        vm.send = function () {
            HelperService.block("#email_body");
            // prepare for backend 
            vm.email.prepareForSave(vm.attachments);

            // send
            EmailService.send(vm.email, vm.copyToMe, SharedAgendaService.currentUser().id).then(function (result) {
                // close modal
                $uibModalInstance.close(result);
                Alert.success("Email send successfully");
                HelperService.unblock("#email_body");
            }).catch(function (result) {                
                $uibModalInstance.dismiss(result);
            });
        };

        // close modal
        vm.cancel = function () {
            // clear all uploaded files
            vm.doClearAll = true;
            // close dialog
            $uibModalInstance.dismiss("abort");
        };

        /* activation work */
        function activate() {
            // listen to event
            listen();
            // set created email
            vm.email = email;
            vm.email.fK_User_Sender = SharedAgendaService.currentUser().id;
            // set uploadUrl
            vm.uploadUrl = AppConfig.ApiUrl + '/api/uploadfiles/foruser/' + SharedAgendaService.currentUser().id;

            // set signature if NEW-Mail 
            if (vm.email.id === undefined || vm.email.id === null || vm.email.id <= 0 && signature) {
                if (vm.email.content === null || typeof vm.email.content === 'undefined') {
                    vm.email.content = '';
                }
                vm.email.content += '<br><br>' + signature;
            }

        }
    }
})();
